import { useEffect, useState } from "react";
import { useOfflineMode } from "../../context/horsLigne/modeHorsLigneContext";
import { useConf } from "../../context/account/paramsAccount";
import { useError } from "../../context/erreur/erreurContext";
import { useNavigate } from "react-router-dom";
import { apiPostWToken } from "../../api/apiPost";
import { loadModeHorsligne } from "../../functions/HorsLigne/loadmodeHL";
import { Link } from "react-router-dom";
import { BottomNavigationSelectEvent } from '@progress/kendo-react-layout';

type ModalMenuProps = {
    selectedIndex: number;
    handleSelect: (e: BottomNavigationSelectEvent) => void;
};

export function ModalMenu({ selectedIndex, handleSelect }: ModalMenuProps) {
    const [currentPage, setCurrentPage] = useState("");
    const [valueCurrentPage, setValueCurrentPage] = useState("");
    const [isOffLine, setIsOffLine] = useState(false)
    const { conf, setConf } = useConf()
    const { showError } = useError();
    const [listePresta, setListePresta]: any = useState()
    useEffect(() => {
        if (conf.conf.ifOffLineMode) {
            setIsOffLine(conf.conf.ifOffLineMode)
        }
        else {
            setIsOffLine(false)
        }
    }, [conf.conf.ifOffLineMode])
    const getPageTitle = (pathname: string): string => {
        if (pathname.includes("/planning")) return "Planning";
        if (pathname.includes("/connexion")) return "Connexion";
        if (pathname.includes("/parametre")) return "Paramètres";
        if (pathname.includes("/retour-prestation")) return "Retour de prestation";
        if (pathname.includes("/affiche-presta")) return "Prestation";
        if (pathname.includes("/mode-hors-ligne")) return "Mode Hors Ligne";
        return "";
    };

    useEffect(() => {
        const pathname = window.location.pathname;
        setCurrentPage(pathname);
        setValueCurrentPage(getPageTitle(pathname));
    }, [window.location.pathname]);



    const deconnexionUser = () => {
        const id = { id: conf.user.id, url: conf.user.url };
        apiPostWToken('/posts/user-logout', id, conf.token, conf, setConf, showError)
            .then(() => {
                window.location.href = '/';
            })
            .catch((err) => {
                console.error('Erreur de déconnexion:', err);
            });
    };
    useEffect(() => {
        loadModeHorsligne('prestaHl', conf)
            .then(data => {
                if (data) {
                    const entetes = data.map((item: any) => item?.entete);
                    if (entetes) {
                        setListePresta(entetes)
                    }
                } else {
                    setListePresta(undefined)
                }
            })
            .catch(error => console.error('Erreur lors du chargement des données hors ligne :', error));
    }, [conf])
    // const checkPresta = () => {
    //     loadModeHorsligne('prestaHl',conf)
    //         .then(data => {
    //             if (data) {
    //                 const entetes = data.map((item: any) => item?.entete);
    //                 if (entetes) {
    //                     handleActivateOfflineMode(setConf, conf, toggleOfflineMode,)
    //                     setListePresta(entetes)
    //                 }
    //             } else {
    //                 setListePresta(undefined)
    //                 redirection(navigate, "/mode-hors-ligne")
    //             }
    //         })
    //         .catch(error => console.error('Erreur lors du chargement des données hors ligne :', error));
    // }
    return <div className="modalMenu">
        <div>
            <div className="containerUser">
                <div className="nameUser">
                    <Link
                        to={"/parametre"}
                        className="user"
                        onClick={() => handleSelect({ itemIndex: selectedIndex } as BottomNavigationSelectEvent)}
                    >
                        <svg
                            className="svgProfilModal"
                            xmlns="http://www.w3.org/2000/svg"
                            height="1em"
                            viewBox="0 0 448 512"
                        >
                            <path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z" />
                        </svg>
                        <p className="textUser">{conf?.conf?.authenticated?.u_nom}</p>
                    </Link>
                </div>
                <div className="nameUser">
                    <Link
                        to={"/parametre"}
                        className="user"
                        onClick={() => handleSelect({ itemIndex: selectedIndex } as BottomNavigationSelectEvent)}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="svgProfilModal"
                            height="1em"
                            viewBox="0 0 512 512"
                        >
                            <path d="M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z" />
                        </svg>
                        <p className="textUser">{conf?.user?.site?.sit_id} {conf?.user?.site?.sit_nom}</p>
                    </Link>
                </div>


                <div
                    className="deconnexion"
                    onClick={() => handleSelect({ itemIndex: selectedIndex } as BottomNavigationSelectEvent)}
                >
                    <svg xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 512"
                        className="svgProfilModal"
                        height="1em"                                    >
                        <path d="M576 0c17.7 0 32 14.3 32 32l0 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-448c0-17.7 14.3-32 32-32zM448 96c17.7 0 32 14.3 32 32l0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352c0-17.7 14.3-32 32-32zM352 224l0 256c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32s32 14.3 32 32zM192 288c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32zM96 416l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32z" />
                    </svg>
                    <Link to={"/mode-hors-ligne"} className="textUser">{"Mode hors ligne"}</Link>
                </div>

                <div
                    className="deconnexion"
                    onClick={() => {
                        deconnexionUser()
                        handleSelect({ itemIndex: selectedIndex } as BottomNavigationSelectEvent)
                    }
                    }
                >
                    <svg
                        className="svgProfilModal"
                        xmlns="http://www.w3.org/2000/svg"
                        height="1em"
                        viewBox="0 0 512 512"
                    >
                        <path d="M217.9 105.9L340.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM352 416l64 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z" />
                    </svg>
                    <p className="textUser">Me déconnecter</p>
                </div>
            </div>

            {/* <button onClick={openScanner}>TAKEPHOTO</button> */}
        </div>
    </div>
}